module.exports = __webpack_public_path__ + "img/next-gen.28168dde.png";